import { Card } from '@/components_deprecated/Card'
import type { ChecklistProps } from './CheckList';
import { Checklist } from './CheckList'

export const ChecklistCard: React.JSX.CFC<ChecklistProps> = ({
  checklist,
  ...rest
}) => {
  if (checklist === null) return null
  return (
    <Card>
      <Checklist checklist={checklist} {...rest} />
    </Card>
  )
}
